import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignMetricsHandoff } from '@/pages/workspaces/automations/[campaignId]/metrics/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/metrics',
)({
  component: JourneysCampaignMetricsHandoff,
});
